import { useEffect, useMemo, useState } from "react";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { Add, HelpOutline } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LogoutContainer from "../../Layout/LogoutContainer";
import { PageTitleSubtitle, StyledHeader } from "../../Common/styles/header";
import UsersList from "./UsersList";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { openHelp } from "../../../Redux/reducers/helpSlice";
import { platformAdminPermissions } from "../../../utils/roles";

const Users = () => {
  const { t: sidebarT } = useTranslation("sidebar");
  const dispatch = useAppDispatch();
  const { platformPermissions } = useAppSelector((state) => state.user);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchText, setSearchText] = useState(searchParams.get("query") ?? "");
  const [showModal, setShowModal] = useState(false);
  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.managePlatform),
    [platformPermissions],
  );

  useEffect(() => {
    const params = new URLSearchParams();

    if (searchText) {
      params.set("query", searchText);
    }

    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, searchText]);

  return (
    <>
      <Box
        sx={{
          height: "64px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <Box sx={{ ml: "auto" }}>
          <LogoutContainer />
        </Box>
      </Box>
      <StyledHeader>
        <PageTitleSubtitle
          title="Users"
          subtitle="Manage and monitor user accounts."
        />

        <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 1 }}>
          {canEdit && (
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setShowModal(true)}
            >
              New User
            </Button>
          )}
          <Tooltip title={sidebarT("HELP_TOOLTIP")}>
            <IconButton onClick={() => dispatch(openHelp("platform-users"))} size="small">
              <HelpOutline />
            </IconButton>
          </Tooltip>
        </Box>
      </StyledHeader>
      <Box sx={{ p: 5, height: "calc(100% - 154px)", overflow: "auto" }}>
        <UsersList
          searchText={searchText}
          showModal={showModal}
          setShowModal={setShowModal}
          setSearchText={setSearchText}
          canEdit={canEdit}
        />
      </Box>
    </>
  );
};

export default Users;
